import React, { useState } from 'react';
// import TriangleSelector from '../components/TriangleSelector';
import Survey from '../components/Survey';
import ContactForm from '../components/ContactForm';
import './Home.css';
import FreioLabsLogo from '../assets/logo/FL-Logo-Blue-Circle-Bold-White-Beaker.png';
import WorkoutFlowLogo from '../assets/creations/workoutFlow/WF-Logo-Selected-512.png'; // Assuming this is the chosen logo
import GForceMonitorLogo from '../assets/creations/g-force-monitor/G-Force-Monitor-Logo-NB.png';

const Home: React.FC = () => {
  const [showSurvey, setShowSurvey] = useState(false);
  const [surveyData, setSurveyData] = useState<any>(null);
  const [showContactForm, setShowContactForm] = useState(false);

  const handleStartProject = () => {
    setShowSurvey(true);
  };

  const handleSurveyComplete = (data: any) => {
    setSurveyData(data);
    setShowContactForm(true);
  };

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <div className="logo-container">
            <img src={FreioLabsLogo} className="hero-logo" alt="FreioLabs" />
          </div>
          <h1 className="hero-title">
            <span className="text-gradient">FreioLabs</span>
          </h1>
          <p className="hero-subtitle">
            We build the future, one app at a time
          </p>
          <div className="cta-container">
            <button onClick={handleStartProject} className="cta-button">
              Start Your Project
              <span className="button-glow"></span>
            </button>
          </div>
        </div>
      </section>

      <section className="apps-showcase">
        <div className="container">
          <h2 className="section-title">Our Applications</h2>
          <div className="apps-grid">
            <div className="app-card">
              <img src={WorkoutFlowLogo} alt="Workout Flow" className="app-icon-img" style={{height: "50px", marginBottom: "1.5rem"}} />
              <h3>Workout Flow</h3>
              <p>AI-powered fitness companion</p>
            </div>
            <div className="app-card">
              <img src={GForceMonitorLogo} alt="G-Force Monitor" className="app-icon-img" style={{height: "50px", marginBottom: "1.5rem"}} />
              <h3>G-Force Monitor</h3>
              <p>Real-time acceleration tracking</p>
            </div>
            <div className="app-card">
              <div className="app-icon">⚡</div>
              <h3>Coming Soon</h3>
              <p>Next-gen solutions</p>
            </div>
          </div>
        </div>
      </section>

      <section className="capabilities">
        <div className="container">
          <h2 className="section-title">What We Create</h2>
          <div className="capabilities-grid">
            <div className="capability-item">
              <div className="capability-icon">📱</div>
              <h3>Mobile Apps</h3>
              <p>iOS & Android native experiences</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🌐</div>
              <h3>Web Applications</h3>
              <p>Scalable, responsive platforms</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🤖</div>
              <h3>AI Integration</h3>
              <p>Intelligent, adaptive solutions</p>
            </div>
          </div>
        </div>
      </section>

      {showSurvey && !showContactForm && (
        <Survey onComplete={handleSurveyComplete} onClose={() => setShowSurvey(false)} />
      )}

      {showContactForm && (
        <ContactForm 
          surveyData={surveyData} 
          onClose={() => {
            setShowContactForm(false);
            setShowSurvey(false);
            setSurveyData(null);
          }} 
        />
      )}
    </div>
  );
};

export default Home;